import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../siteConfig.js";

export default function About() {
  return (
    <div className="container section">
      <div className="pageHero">
        <div className="pageHeroText">
          <span className="eyebrow">Who we are</span>
          <div className="pageHeroTitle">Built in Kenya,<br />for Kenya.</div>
          <p className="pageHeroSub">
            {siteConfig.companyLegalName} is the technology company behind Rahisi — a digital retail platform
            connecting shoppers with local merchants across Nairobi and beyond.
          </p>
        </div>
      </div>

      <img src="/tablet_bg_5.png" alt="Mtaani team and operations" className="pageBanner" />

      <div className="prose">
        <h3 className="h3">What we do</h3>
        <p>
          We build and operate digital systems that bring local retail into the mobile age. Through the Rahisi app,
          customers can discover products, access exclusive deals, and receive same-day delivery — while merchants
          gain a reliable digital storefront and riders earn on a flexible schedule.
        </p>

        <h3 className="h3">Our mission</h3>
        <p>
          To make everyday shopping faster, more accessible, and more transparent for people across Kenya —
          starting with Nairobi's neighbourhoods.
        </p>

        <h3 className="h3">How we operate</h3>
        <p>
          {siteConfig.companyLegalName} operates with a focus on clarity, reliability, and responsible data practices.
          Our processes are designed to be practical and proportional to the nature of our services, with defined
          responsibilities and documented policies available publicly on this site.
        </p>

        <h3 className="h3">Our commitments</h3>
        <ul>
          <li>Transparent pricing — no hidden fees for customers or merchants.</li>
          <li>Data minimisation — we collect only what we need to deliver the service.</li>
          <li>Rider fairness — earnings are visible, trackable, and paid reliably.</li>
          <li>Merchant control — sellers manage their own inventory, pricing, and promotions.</li>
          <li>Continuous improvement — we listen to feedback and ship updates regularly.</li>
        </ul>
      </div>

      <div className="grid3" style={{ marginTop: "40px" }}>
        <div className="card">
          <div className="cardTitle">🏙️ Headquartered in Nairobi</div>
          <p className="muted" style={{ fontSize: "14px" }}>Our operations, engineering, and support teams are all Kenya-based.</p>
        </div>
        <div className="card">
          <div className="cardTitle">📱 Mobile-first</div>
          <p className="muted" style={{ fontSize: "14px" }}>Rahisi is built specifically for Android — the dominant platform across Kenya.</p>
        </div>
        <div className="card">
          <div className="cardTitle">🔒 Compliance-minded</div>
          <p className="muted" style={{ fontSize: "14px" }}>We maintain published privacy and governance policies, updated and publicly accessible.</p>
        </div>
      </div>

      <div className="inlineLinks" style={{ marginTop: "40px" }}>
        <Link to="/governance">Governance & Compliance</Link>
        <span className="dot">•</span>
        <Link to="/contact">Contact Us</Link>
        <span className="dot">•</span>
        <Link to="/our-app">The Rahisi App</Link>
      </div>
    </div>
  );
}
